const NS = 'VideoBlock';
const CLS = 'videoBlock';

import { utils } from '../../../../global/js/utils';

export class VideoBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$video = this.$element.find('video');
		this.$iframe = this.$element.find(`.${CLS}-iframe`);

		this.videoType = this.$element.data('videoType');
		this.videoId = this.$element.data('videoSrcId');

		this.initVideo();
	}

	initVideo() {
		// local video
		if(this.$video && this.$video.length > 0) {
			let $sources = $video.find('source');
			if($sources && $sources.length > 0) {
				let $lastSource = $sources.last();

				$lastSource[0].addEventListener('error', () => {
					console.error(`${NS}::Error`, 'The video could not be loaded');
				}, true);
			}
		} else {
			if (this.$iframe.length === 0 || !this.videoId) return;
			let embedLink = '';

			switch (this.videoType) {
				case utils.VID_TYPE.youku:
					embedLink = `https://player.youku.com/embed/${this.videoId}?autoplay=0&rel=0`;
					break;

				default:
					// set default as youtube
					embedLink = `https://www.youtube.com/embed/${this.videoId}?autoplay=0&rel=0&showinfo=0`;
					break;
			}

			this.$iframe.attr('src', embedLink);
		}
	}
}
